<template>
    <div class="com-vip-button-box">
        <button class="com-vip-button" @click="clickVipButton">
            <p class="title">{{ frompage == 'report' && userData && userData.vip < 20 ? '一键免费解锁' : frompage == 'year' && userData && userData.vip < 30 ? '终身会员一键免费解锁所有年运' : '特权免费解锁' }} </p>
            <p v-if="vipDayLuckType == 2 && vipYearUpTimeSecond > 0" class="sub-title">（年会员可享超值限时<span class="red2">补差价998-288</span>升级，<span class="red2">{{ vipYearUpTimeStr }}</span>后结束！）</p>
            <p v-else-if="vipDayLuckType != 2 && vipDayLuckInfo && userData && userData.vip < 30" class="sub-title">（每日限量特惠放送，今日还剩<span class="red2">{{ vipDayLuckInfo.num }}</span>位）</p>
        </button>
    </div>
</template>

<script>
import { ACTIVITY_DOM } from '../../modules/dom';

export default {
    name: 'VipYearButton',
    computed: {
        userData() {
            return this.$store.state.userData ? this.$store.state.userData.info : {};
        },
        vipDayLuckType() {
            return this.$store.state.user.vipDayLuckType;
        },
        vipYearUpTimeSecond() {
            return this.$store.state.user.vipYearUpTimeSecond;
        },
        vipYearUpTimeStr() {
            return this.$store.state.user.vipYearUpTimeStr;
        },
        vipDayLuckInfo() {
            return this.$store.state.user.vipDayLuckInfo;
        },
    },
    props: {
        frompage: {
            type: String,
            default() { return '' }
        }
    },
    methods: {
        clickVipButton() {
            var detailInfo = this.$store.state.detail.personInfo;
            if(!detailInfo || !detailInfo.id) { return; }
            console.log('clickVipButton----', detailInfo.id)
            if((this.frompage == 'report' && this.userData && parseInt(this.userData.vip) < 20) || (this.frompage == 'year' && this.userData && parseInt(this.userData.vip) < 30)) {
                this.$store.state.user.showActDayLuckPop = true;
                setTimeout(() => {
                    ACTIVITY_DOM.updateActivityDayLuckDom();
                }, 100);
            }else {
                // 免费解锁测算
                if(this.frompage == 'report') {
                    this.$store.dispatch('report/freeUnlockReport', {
                        detailInfo: detailInfo,
                        frompage: this.frompage,
                        sucCb: ()=> {
                            this.$bus.emit('showReportSuc');
                        },
                        failCb: ()=> {
                            this.$toast('免费解锁失败，请稍后再试');
                        }
                    });
                // 免费解锁年报
                }else if(this.frompage == 'year') {
                    var yearReportData = this.$store.state.year.curYearReportData;
                    console.log('免费解锁', yearReportData)
                    this.$store.dispatch('year/freeUnlockYearReport', {
                        id: yearReportData.id,
                        sucCb: ()=> {
                            this.$bus.emit('showYearReportSuc');
                            this.$store.dispatch('year/resetYearData');
                            this.$store.dispatch('year/getYearReportInfo');
                        },
                        failCb: ()=> {
                            this.$toast('免费解锁失败，请稍后再试');
                        }
                    });
                }
            }
        }
    }
}
</script>